import { render } from "./RModal.vue?vue&type=template&id=7934355a"
import script from "./RModal.vue?vue&type=script&lang=js"
export * from "./RModal.vue?vue&type=script&lang=js"

import "./RModal.vue?vue&type=style&index=0&id=7934355a&lang=css"
script.render = render

export default script